<template>
    <spoiled-drop-zone @over="dragging = $event" @file="load($event)">
        <v-file-input
            solo
            flat
            prepend-icon=""
            prepend-inner-icon="mdi-folder-open"
            placeholder="Drop or select spoiler file"
            :error-messages="error"
            @change="load($event)"
            :loading="loading"
            :disabled="loading"
            accept="application/json"
            :background-color="dragging ? 'primary' : ''"
        />
    </spoiled-drop-zone>
</template>

<script>
import SpoiledDropZone from "@/components/base/SpoiledDropZone.vue";
import debug from "@/helper/debug";

export default {
    name: "SpoiledUpload",
    components: {SpoiledDropZone},
    data: function () {
        return {
            dragging: false,
            loading: false,
            error: null,
        };
    },
    methods: {
        load(file) {
            this.error = null;
            if (!file) return;

            this.loading = true;
            let read = new FileReader();

            read.onload = e => {
                this.$store.dispatch('Log/load', e.target.result.toString())
                    .catch((error) => debug.error(this.error = error))
                    .finally(() => this.loading = false);
            }

            read.readAsText(file);
        },
    },
}
</script>

<style scoped>
/deep/ .v-text-field__slot {
    cursor: pointer;
}
/deep/ input {
    display: none;
}
</style>